import api from './api'

/**
 * Serviço de Administração (Bootstrap)
 */
export default {
  /**
   * Criar Dono da Plataforma
   */
  createPlatformOwner(data) {
    return api.post('/api/admin/bootstrap/platform-owner', data)
  },

  /**
   * Criar Conta SaaS Principal
   */
  createSaaSAccount(data) {
    return api.post('/api/admin/bootstrap/saas-account', data)
  },

  /**
   * Criar Tenant do Sistema
   */
  createSystemTenant(data) {
    return api.post('/api/admin/bootstrap/tenant', data)
  },

  /**
   * Criar Administrador de Parceiro
   */
  createPartnerAdmin(data) {
    return api.post('/api/admin/bootstrap/partner-admin', data)
  },
}
